<template>
    <div>
    <card-dashboard 
        id="card-projetos-saldo"
        bg-variante="warning" 
        icone="fa-solid fa-file-invoice-dollar" 
        titulo="" 
        :valor="valor"
        titulo-modal="Saldo dos projetos"
        :colunas="colunas"
        :dados="dados"
    >
        <template #titulo>
            <span>
                Saldo dos<br/>projetos
            </span>
        </template>
    </card-dashboard>
    </div>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardExecutoraService from "@/common/services/dashboards/dashboard_executora.service";
import helpers from "@/common/utils/helpers";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        valor : 0,
        colunas : [
            { key : "projeto",  label : "Código do projeto"},
            { key : "empresa",  label : "Empresa"},
            { key : "rh.previsto", label : "RH Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "rh.realizado", label : "RH Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "st.previsto", label : "ST Previsto" , formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "st.realizado", label : "ST Realizado" , formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "mc.previsto", label : "MC Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mc.realizado", label : "MC Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mp.previsto", label : "MPE Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mp.realizado", label : "MPE Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "vd.previsto", label : "VD Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "vd.realizado", label : "VD Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ou.previsto", label : "OU Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ou.realizado", label : "OU Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
        ],
        dados : [],
    }),
    methods : {
        buscarDados(){
            DashboardExecutoraService.saldoDosProjetos(this.empresasSelecionada).then(response => {
                this.dados = response.data.data;
                this.valor = helpers.formatarValor(this.somarValoresObjetosPadrao(response.data.data));
            });
        },
        somarValoresObjetosPadrao: function(obj){
            return obj.reduce((valorAnterior, el) => {
                return valorAnterior + (
                    (!el.rh ? 0 : (el.rh.previsto - el.rh.realizado)) +
                    (!el.st ? 0 : (el.st.previsto - el.st.realizado)) +
                    (!el.mc ? 0 : (el.mc.previsto - el.mc.realizado)) +
                    (!el.mp ? 0 : (el.mp.previsto - el.mp.realizado)) +
                    (!el.vd ? 0 : (el.vd.previsto - el.vd.realizado)) +
                    (!el.ou ? 0 : (el.ou.previsto - el.ou.realizado)) +
                    (!el.ac ? 0 : (el.ac.previsto - el.ac.realizado)) +
                    (!el.ci ? 0 : (el.ci.previsto - el.ci.realizado))
                );
            }, 0)
        },
    },
    computed : {
        empresasSelecionada : function(){
            if(!this.$store.state.app.selectedCompanyObj)
                return null;
            return this.$store.state.app.selectedCompanyObj.id;  
        },
    }
    
}
</script>
<style lang="">
    
</style>